export const instance = new Routing(
    require('jquery'),
    require('axios'),
    window.app,
    $document
);

function Routing($, axios, app, $document) {
    let cache = {};
    let loading = {};
    initEvents();
    setActiveA(window.location.pathname);
    cacheLoadedPage();

    function initEvents() {
        $document.on('click', '.js-route', function (e) {
            e.preventDefault();
            loadPage(this.href);
        });
    }

    function loadPage(url) {
        let urlForCache = getUrlForCache(url);

        if (loading[urlForCache]) {
            app.log.notice('already loading', urlForCache);
            return false;
        }
        loading[urlForCache] = true;

        app.nprogress.start();

        if (typeof cache[urlForCache] !== "undefined") {
            loadPageSuccess();
            return;
        }

        axios.get(url)
            .then(function (response) {
                cache[urlForCache] = response.data;
                loadPageSuccess();
            })
            .catch(function (response) {
                app.log.error(response.message, response);
                loadPageFinally();
            });

        function loadPageSuccess() {
            setActiveA(url);
            app.url.setNewUrl(url);
            showPage(cache[urlForCache]);
            loadPageFinally();
        }

        function loadPageFinally() {
            app.nprogress.done();
            delete loading[urlForCache];
        }
    }

    function setActiveA(url) {
        $('a.__active[href="' + getShortUrl(window.location.pathname).replace(/"/g, '\\"') + '"]').removeClass('__active');
        $('a[href="' + getShortUrl(url).replace(/"/g, '\\"') + '"]').addClass('__active');
    }

    function showPage(html) {
        let $html = $('<div>' + html + '</div>');
        $html.find("[data-routing-replace]").each(function () {
            let $this = $(this);
            $($this.data('routing-replace')).html($this.html());
        });
    }

    function cacheLoadedPage() {
        $(function () {
            cache[getUrlForCache(window.location.pathname)] = document.documentElement.outerHTML;
        });
    }

    function getShortUrl(url) {
        return url.replace(window.location.origin, '');
    }

    function getUrlForCache(url) {
        return getShortUrl(url)
            .replace(/\/$/, '');
    }

    return {
        loadPage: loadPage,
    }
}


